import type { ReactNode } from 'react'
import { usePartner, useLogout } from '@/features/auth/hooks'
import { layoutTexts } from './layout.texts'

interface MainLayoutProps {
  children: ReactNode
}

/**
 * Top-header layout for the partner portal: brand on the left, partner name
 * and logout on the right, content centered below. Mobile-friendly (partners
 * mostly open this on their phones).
 */
export const MainLayout = ({ children }: MainLayoutProps) => {
  const { partner } = usePartner()
  const logout = useLogout()

  return (
    <div className="min-h-screen bg-background-app">
      <header className="bg-gradient-brand text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <div className="flex items-baseline gap-2 min-w-0">
            <span className="text-lg font-semibold whitespace-nowrap">
              {layoutTexts.header.brand}
            </span>
            <span className="hidden sm:inline text-sm text-white/70 whitespace-nowrap">
              {layoutTexts.header.brandSuffix}
            </span>
          </div>
          <div className="flex items-center gap-3 sm:gap-4 min-w-0">
            {partner && (
              <span className="text-sm text-white/90 truncate max-w-[140px] sm:max-w-none">
                {partner.name}
              </span>
            )}
            <button
              type="button"
              onClick={logout}
              className="text-sm font-medium px-3 py-1.5 rounded-md border border-white/30 hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              {layoutTexts.header.logout}
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-10 animate-fade-in">
        {children}
      </main>
    </div>
  )
}
